"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { smartFetch } from '../foundation/smartfetch';
/*
NOTE : development has stopped for this component
as Yelp Base API Access costs $229 per month.
Not ok.
*/
/*
https://www.yelp.com/developers
https://www.google.com/search?q=yelp+reviews+react+component&oq=yelp+reviews+react+component&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigATIHCAUQIRigATIHCAYQIRirAtIBCDYzOThqMWo3qAIAsAIA&sourceid=chrome&ie=UTF-8
https://www.reddit.com/r/nextjs/comments/16smhqa/next_js_fetching_data_from_yelp_api/
https://helloputnam.medium.com/easiest-way-to-include-business-reviews-on-a-web-app-google-facebook-yelp-etc-de3e243bbe75
*/
/**
 * YelpReviews — Fetch and display Yelp reviews for a given business ID (note: Yelp API access may require paid plan).
 *
 * @param {string} [props.businessID] - Yelp business ID used to fetch reviews (required).
 * @param {string} [props.key] - Optional API key (not used by the demo placeholder implementation).
 */
YelpReviews.propTypes = {
    /** Yelp business identifier */
    businessID: PropTypes.string.isRequired,
    /** Optional Yelp API key */
    key: PropTypes.string,
};
export function YelpReviews(props) {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const safeSetState = (setter, value) => {
        if (typeof window !== 'undefined') {
            setter(value);
        }
    };
    useEffect(() => {
        let isMounted = true;
        const fetchReviews = async () => {
            if (typeof window === 'undefined' || !isMounted) {
                return;
            }
            const apiKey = 'YOUR_YELP_API_KEY';
            const url = `https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3/businesses/${props.businessID}/reviews`;
            try {
                const data = await smartFetch(url, {
                    requestInit: {
                        headers: {
                            Authorization: `Bearer ${apiKey}`,
                        },
                    },
                });
                if (!isMounted)
                    return;
                safeSetState(setReviews, data.reviews);
                safeSetState(setLoading, false);
            }
            catch (e) {
                if (!isMounted)
                    return;
                safeSetState(setError, e);
                safeSetState(setLoading, false);
            }
        };
        fetchReviews();
        return () => {
            isMounted = false;
        };
    }, [props.businessID]);
    if (loading) {
        return _jsx("p", { children: "Loading reviews..." });
    }
    if (error) {
        return _jsxs("p", { children: ["Error: ", error.message] });
    }
    return (_jsxs("div", { children: [_jsx("h3", { children: "Yelp Reviews" }), reviews.map((review) => (_jsxs("div", { className: "review", children: [_jsxs("p", { className: "rating", children: ["Rating: ", review.rating] }), _jsx("p", { className: "text", children: review.text }), _jsxs("p", { className: "user", children: ["- ", review.user.name] }), _jsx("hr", {})] }, review.id)))] }));
}
